import React, { useEffect } from 'react';

import { wrapFunctionalComponent } from 'utils/framework';
import Modal from 'components/Modal/Modal';
import { useSelector } from 'react-redux';
import { newShipAddressModalSelector } from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/NewShipAddressModal/newShipAddresModalSelector';
import { Text } from 'components/ui';
import FrictionlessCheckoutBindings from 'analytics/bindingMethods/pages/FrictionlessCheckout/FrictionlessCheckoutBindings';

function NewShipAddressModal({ onDismiss, isOpen, children, isSingleAddress }) {
    const { selectNewDefaultAddress, selectNewDefaultAddressLabel, defaultAddressUpdated, defaultAddressUpdatedTitle } =
        useSelector(newShipAddressModalSelector);

    useEffect(() => {
        if (isOpen) {
            FrictionlessCheckoutBindings.newDefaultAddressAnalytics(isSingleAddress ? 'default address confirmation' : 'select default address');
        }
    }, [isOpen, isSingleAddress]);

    return (
        <Modal
            isOpen={isOpen}
            hasBodyScroll={true}
            width={0}
            focusDialog={true}
            isDrawer={true}
            disableDismiss
            onDismiss={onDismiss}
        >
            <Modal.Header>
                <Modal.Title>{isSingleAddress ? defaultAddressUpdatedTitle : selectNewDefaultAddress}</Modal.Title>
            </Modal.Header>
            <Modal.Body paddingBottom={4}>
                <Text
                    is='p'
                    marginBottom={2}
                >
                    {isSingleAddress ? defaultAddressUpdated : selectNewDefaultAddressLabel}
                </Text>
                {children}
            </Modal.Body>
        </Modal>
    );
}

export default wrapFunctionalComponent(NewShipAddressModal, 'NewShipAddressModal');
